<div class="interval-container">
  <!-- History Container -->
  <div class="history-container">
    <h3>History</h3>
    <div class="history-checkbox-container">
        <div class="checkbox-item">
            <input type="checkbox" id="intervalFollowUp" [(ngModel)]="intervalFollowUp">
            <label for="intervalFollowUp">Interval/Follow up</label>
          </div>
    </div>
  </div>

  <!-- Physical Examination Container -->
  <div class="physical-exam-container">
    <h3>Physical Examination</h3>
    <div class="checkbox-grid">
      <div class="checkbox-column">
        <div class="checkbox-item" *ngFor="let option of physicalExamOptions.slice(0, 6)">
          <input
            type="checkbox"
            [value]="option.id"
            [id]="option.id"
            [checked]="selectedIds.includes(option.id)"
            (change)="onCheckboxChange(option.id, $event)">
          <label [for]="option.id">{{ option.type }}</label>
        </div>
      </div>
      <div class="checkbox-column">
        <div class="checkbox-item" *ngFor="let option of physicalExamOptions.slice(6)">
          <input
            type="checkbox"
            [value]="option.id"
            [id]="option.id"
            [checked]="selectedIds.includes(option.id)"
            (change)="onCheckboxChange(option.id, $event)">
          <label [for]="option.id">{{ option.type }}</label>
        </div>
        
      </div>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="action-buttons">
    <button class="ok-btn" (click)="onOkClick()">OK</button>
    <button class="clear-btn" (click)="onClearClick()">Clear</button>
    
  </div>
  <hr>
</div> 

<!-- Patient Interval Dialog -->
<div class="dialog-overlay" *ngIf="showPatientInterval">
  <div class="dialog-box">
    <div class="dialog-header">
      <h2>Interval/Follow-up</h2>
    </div>
    <div class="content-wrapper">
      <div class="dialog-content">
        <div class="content">
          <p>{{ patientIntervalDescription }}</p>
        </div>
        <div class="button-wrapper">
          <button class="btn-style" (click)="closePatientInterval()">OK</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Interval Confirmation Dialog -->
<div class="dialog-overlay" *ngIf="showIntervalConfirmation">
    <div class="dialog-box">
      <div class="dialog-header">
        <h2>Confirm Interval Choices</h2>
      
      </div>
      <div class="content-wrapper">
          <div class="dialog-content">
            <div class="content">
              <div class="exam-wrapper">
                <p>Interval/Follow-up : 2</p>
              </div>

              <div class="total-minutes">
                Total Minutes = {{totalMinutes}}
              </div>

              <div class="total-minutes">
                This will advance the clock to {{futureTime}}
              </div>
            </div>
          <div class="button-wrapper">
              <button class=btn-style (click)="showIntervalDetails()">OK</button>
              <button class=btn-style (click)="showIntervalConfirmation=false">Cancel</button>
          </div>
      </div>
    </div>
  </div>
</div>

<div class="dialog-overlay" *ngIf="showConfirmation">
    <div class="dialog-box">
      <div class="dialog-header">
        <h2>Confirm H&P Choices</h2>
      
      </div>
      <div class="content-wrapper">
          <div class="dialog-content">
            <div class="content">
              <div *ngFor="let option of selectedOptions" class="exam-wrapper">
                <p>{{option.type}}</p>
                <p>{{option.duration}} min</p>
              </div>

              <div class="total-minutes">
                Total Minutes = {{totalMinutes}}
              </div>

              <div class="total-minutes">
                This will advance the clock to {{futureTime}}
              </div>
            </div>
          <div class="button-wrapper">
              <button class=btn-style (click)="showDetails()">OK</button>
              <button class=btn-style (click)="showConfirmation=false">Cancel</button>
          </div>
      </div>
    </div>
  </div>
</div>

<div class="dialog-overlay" *ngIf="showPhysicalExamination">
  <div class="dialog-box">
    <div class="dialog-header">
      <h2>History and Physical</h2>
    
    </div>
    <div class="content-wrapper">
        <div class="dialog-content">
          <div class="content">
            <div *ngFor="let option of selectedOptions" class="examination-row">
              <h3>{{option.type}}</h3>
              <p>{{option.response || option.description || 'No response available'}}</p>
            </div>

            
          </div>
        <div class="button-wrapper">
            <button class=btn-style (click)="closeExamination()">OK</button>
            
        </div>
    </div>
  </div>
</div>
</div>